import styled from 'styled-components';
import Text from '../Text';
import { withTheme } from '../../core/ThemeProvider';
import { VOUCHER_STATUS } from './VoucherItem';
import VoucherLeftCorner from './assets/voucher_left.svg';
import VoucherRightCorner from './assets/voucher_right.svg';
export var StyledVoucherLeftCorner = styled(VoucherLeftCorner).withConfig({
  displayName: "styles__StyledVoucherLeftCorner",
  componentId: "sc-1uz20mu-0"
})(["height:100%;"]);
export var StyledVoucherRightCorner = styled(VoucherRightCorner).withConfig({
  displayName: "styles__StyledVoucherRightCorner",
  componentId: "sc-1uz20mu-1"
})(["height:100%;width:124px;"]);
export var StyledVoucherContentCorner = styled.div.withConfig({
  displayName: "styles__StyledVoucherContentCorner",
  componentId: "sc-1uz20mu-2"
})(["min-width:100px;flex-wrap:nowrap;flex:1 1 auto;margin-left:-1px;display:flex;align-items:center;"]);
export var StyledText = styled(Text).withConfig({
  displayName: "styles__StyledText",
  componentId: "sc-1uz20mu-3"
})(["", ""], function (props) {
  return props.type !== 'link' && "\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;";
});
export var StyledAmount = styled(Text).withConfig({
  displayName: "styles__StyledAmount",
  componentId: "sc-1uz20mu-4"
})(["display:block;"]);
export var StyledVoucher = withTheme(styled.div.withConfig({
  displayName: "styles__StyledVoucher",
  componentId: "sc-1uz20mu-5"
})(["position:relative;display:flex;height:128px;margin-bottom:10px;", ""], function (_ref) {
  var type = _ref.type,
    coreTheme = _ref.coreTheme;
  if (type === VOUCHER_STATUS.NOT_AVAILABLE) {
    return "\n      ".concat(StyledText, " {\n        opacity: 0.65;\n        color: ").concat(coreTheme.cl_ter_base, ";\n      }\n      ").concat(StyledAmount, " {\n        opacity: 0.65;\n        color: ").concat(coreTheme.cl_ter_base, ";\n      }\n      ").concat(StyledVoucherLeftCorner, " {\n        fill: ").concat(coreTheme.cl_ter_l5, ";\n      }\n      ").concat(StyledVoucherContentCorner, " {\n        background-color: ").concat(coreTheme.cl_ter_l5, ";\n      }\n      ").concat(StyledVoucherRightCorner, " {\n        fill: ").concat(coreTheme.cl_ter_l5, ";\n      }\n      ");
  } else if (type === VOUCHER_STATUS.SELECTED) {
    return "\n      ".concat(StyledText, " {\n        color: ").concat(coreTheme.cl_white, ";\n      }\n      ").concat(StyledAmount, " {\n        color: ").concat(coreTheme.cl_white, ";\n      }\n      ").concat(StyledVoucherLeftCorner, " {\n        fill: #108668;\n      }\n      ").concat(StyledVoucherContentCorner, " {\n        background-color: #108668;\n      }\n      ").concat(StyledVoucherRightCorner, " {\n        fill: #108668;\n      }\n    ");
  } else {
    return "".concat(StyledAmount, " {\n        color: ").concat(coreTheme.cl_sec_d1, ";\n      }\n      ").concat(StyledVoucherLeftCorner, " {\n        fill: ").concat(coreTheme.cl_sec_l2, ";\n      }\n      ").concat(StyledVoucherContentCorner, " {\n        background-color: ").concat(coreTheme.cl_sec_l2, ";\n      }\n      ").concat(StyledVoucherRightCorner, " {\n        fill: ").concat(coreTheme.cl_sec_l2, ";\n      }\n      ");
  }
}));
export var StyledVoucherContent = styled.div.withConfig({
  displayName: "styles__StyledVoucherContent",
  componentId: "sc-1uz20mu-6"
})(["display:block;overflow:hidden;"]);
export var StyledLeftCorner = styled.div.withConfig({
  displayName: "styles__StyledLeftCorner",
  componentId: "sc-1uz20mu-7"
})(["display:block;"]);
export var StyledRightCorner = styled.div.withConfig({
  displayName: "styles__StyledRightCorner",
  componentId: "sc-1uz20mu-8"
})(["position:relative;margin-left:-1px;text-align:center;"]);
export var StyledRightCornerItem = styled.div.withConfig({
  displayName: "styles__StyledRightCornerItem",
  componentId: "sc-1uz20mu-9"
})(["position:absolute;left:65%;top:50%;transform:translate(-60%,-50%);"]);